export const DECIMAL_PRECISION_MULTIPLIER = 10;
